import React from 'react';

export default function ProductCard({ product, addLabel, onAdd }) {
  return (
    <article className="kido-product-card">
      <div className="kido-product-image" style={{ backgroundColor: product.color }}>
        <img src={product.image} alt={product.en} />
        <button type="button" className="kido-heart" aria-label={`Save ${product.en}`}>♡</button>
        <span className="kido-tag">{product.tag}</span>
      </div>
      <div className="kido-product-info">
        <div>
          <h3>{product.name}</h3>
          <p>{product.en} · {product.ru}</p>
        </div>
        <strong>{product.price}</strong>
      </div>
      <button type="button" className="kido-add-button" onClick={onAdd}>{addLabel} <span>+</span></button>
    </article>
  );
}
